import {
  getEventDetails as getEventDetailsApi,
  patchEventEnd,
  patchEventStart,
  patchEventUpdate, postEventLogoUpload
} from "../../../helpers/event_helper";

// action
import {
  eventGetSuccess,
  eventGetError,
  eventUpdateSuccess,
  eventUpdateError,
  eventStartSuccess,
  eventStartError, eventEndSuccess, eventEndError,
  logoUploadRequest,
  logoUploadSuccess,
  logoUploadError
} from "./reducer";
import {eventSongListDeleteSuccess} from "../view/reducer";

export const getEventDetails = (id) => async (dispatch) => {
  try {
    let response;
    response = getEventDetailsApi(id);
    const data = await response;
    if (data) {
      dispatch(eventGetSuccess(data));
    }
  } catch (error) {
    dispatch(eventGetError(error));
  }
}

export const updateEvent = (id, payload) => async (dispatch) => {
  try {
    let response;
    response = patchEventUpdate(
      id,
      payload
    );
    const data = await response;
    if (data) {
      dispatch(eventUpdateSuccess(data));
    }
  } catch (error) {
    dispatch(eventUpdateError(error));
  }
};

export const startEvent = (id) => async (dispatch) => {
  try {
    let response;
    response = patchEventStart(id, {startAt: new Date()});
    const data = await response;
    if (data) {
      dispatch(eventStartSuccess(data));
    }
  } catch (error) {
    dispatch(eventStartError(error));
  }
};

export const endEvent = (id) => async (dispatch) => {
  try {
    let response;
    response = patchEventEnd(id, {startAt: null});
    const data = await response;
    if (data) {
      dispatch(eventEndSuccess(data));
      dispatch(eventSongListDeleteSuccess());
    }
  } catch (error) {
    dispatch(eventEndError(error));
  }
};

export const uploadEventLogo = (id, file) => async (dispatch) => {
  try {
    dispatch(logoUploadRequest());

    const formData = new FormData();
    formData.append('logo', file);

    const response = await postEventLogoUpload(id, formData);
    if (response) {
      dispatch(logoUploadSuccess(response));
    }
  } catch (error) {
    dispatch(logoUploadError(error));
  }
};
